import { Wifi } from "lucide-react";
import Image from "next/image";

const HomePageNotFound = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-white z-999999">
      <div className="flex flex-col items-center justify-center">
        <div className="flex items-center justify-center gap-3">
          <div className="border border-[#FB2C364D] bg-[#FB2C361A] flex items-center gap-2 py-2 px-4 rounded-full">
            <span className="size-2 bg-[#FF6467] rounded-full"></span>
            <p className="text-[#E30016] ff_poppins font-medium text-sm leading-[20px]">
              Server Offline
            </p>
          </div>

          <div className="border border-[#8E51FF4D] bg-[#8E51FF1A] flex items-center gap-2 py-2 px-4 rounded-full">
            <Wifi className="text-[#8F3EBC]" />
            <p className="text-[#8F3EBC] ff_poppins font-medium text-sm leading-[20px]">
              Server Offline
            </p>
          </div>
        </div>
        <Image
          className="max-w-[255px] lg:max-w-[300px] xl:max-w-[400px] w-full mx-auto mt-6"
          src="/assets/gif/homePageNotFound.gif"
          alt="404"
          width={400}
          height={400}
        />
        <div className="max-w-[865px] mx-6">
          <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-center xl:leading-[75px] font-bold mb-3 sm:mb-0">
            Whoops! Information Overload!{" "}
          </p>
          <p className="text-sm sm:text-lg ff_poppins text-[#727272] xl:leading-[30px] text-center">
            You all were learning so intensely today that you literally blew our
            server's mind. Our engineers are currently gathering the scattered
            brain cells and putting Edvia back together.
          </p>
          <div className="mt-3 border border-[#7C3AED40] bg-[#7C3AED1F] max-w-[400px] mx-auto rounded-[16px] py-4 px-5">
            <p className="text-xs sm:text-sm font-semibold ff_poppins text-[#3C3C3C] text-center leading-[23px]">
              <span className="text-[#8F3EBC]">
                Don't let your brain overheat too!
              </span>{" "}
              Take a five-minute break. We're working fast to get everything
              back to normal.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePageNotFound;
